import React, { Component } from "react";
import queryString from "query-string";

import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { formatNumber } from "../../utils/helpers";
import dayjs from "dayjs";
import Loader from "../general/Loader";

export default class ReporteProduccionRutas extends Component {
    state = {
        rutas: false,
    };
    componentDidMount() {
        this.getReporte();
    }
    getReporte = async () => {
        const token = auth.getToken();

        const res = await fetch(apiUrl(`reportes` + window.location.search), {
            method: "get",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.setState({
                rutas: response.data,
            });
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const { rutas } = this.state;

        if (!rutas) {
            return <Loader />;
        }

        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];
        const query = queryString.parse(window.location.search);

        const totalViajes = rutas.reduce((acc, ruta) => {
            return acc + parseFloat(ruta.viajes);
        }, 0);

        const totalTon = rutas.reduce((acc, ruta) => {
            return acc + parseFloat(ruta.toneladas);
        }, 0);

        rutas.sort((a, b) => {
            return b.toneladas - a.toneladas;
        });

        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>
                        Producción por Rutas
                    </h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {dayjs(query.desde).format("DD/MM/YYYY")} -{" "}
                        {dayjs(query.hasta).format("DD/MM/YYYY")}
                    </div>
                    <div className='col-md-12 p-b-10'></div>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className='float-left'>Rutas: {rutas.length}</div>

                        <div className='float-right'>
                            <h3>
                                <span className='m-r-25'>
                                    TOTAL VIAJES: {totalViajes}
                                </span>{" "}
                                TOTAL TON: {formatNumber(totalTon)}
                            </h3>
                        </div>
                    </div>
                </div>
                <table className='table'>
                    <thead>
                        <tr>
                            <th style={{ width: "45%" }}>Ruta</th>
                            <th>Ficha - Chofer</th>
                            <th className='text-center'>Viajes</th>
                            <th className='text-right'>TON.</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rutas.map((ruta) => {
                            const choferes = ruta.tarjetas
                                .map((tarjeta) => {
                                    return (
                                        tarjeta.ficha +
                                        " - " +
                                        tarjeta.operadores[0].asignadoNombre
                                    );
                                })
                                .filter(
                                    (item, i, ar) => ar.indexOf(item) === i
                                );

                            return (
                                <tr key={ruta.id}>
                                    <td>
                                        <strong>{ruta.nombre}</strong>
                                        <div>
                                            <small>{ruta.descripcion}</small>
                                        </div>
                                    </td>
                                    <td>
                                        {choferes.map((chofer) => (
                                            <div key={chofer}>{chofer}</div>
                                        ))}
                                    </td>
                                    <td className='text-center'>
                                        {ruta.viajes}
                                    </td>
                                    <td className='text-right'>
                                        {formatNumber(ruta.toneladas)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className='m-t-25'>
                    <div className='float-left'>Tickets: {rutas.length}</div>
                    <div className='text-right float-right'>
                        <h3>
                            <span className='m-r-25'>
                                TOTAL VIAJES: {totalViajes}
                            </span>{" "}
                            TOTAL TON: {formatNumber(totalTon)}
                        </h3>
                    </div>
                </div>
            </div>
        );
    }
}
